/**
 * @generated SignedSource<<bb6abf93834b11992d86bf3bbb19ea1e>>
 * @relayHash faecde0c4187043790f422fa9ae103eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID afa7c21c2f3a4acbbc478474f7da45111834eaccb972c521e753d4cfed489ca9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HeaderControlPanelContentQuery } from './HeaderControlPanelContentQuery.graphql';

import isSearchInputFilterEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/header-control-panel/../../../is-search-input-filter-enabled.relayprovider';

const node: PreloadableConcreteRequest<HeaderControlPanelContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "afa7c21c2f3a4acbbc478474f7da45111834eaccb972c521e753d4cfed489ca9",
    "metadata": {},
    "name": "HeaderControlPanelContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__issearchinputfilterenabledrelayprovidertsx": isSearchInputFilterEnabled_provider
    }
  }
};

export default node;
